/*
import {
  hf,
  ht,
  cr,
  a,
  BoxC,
  BtnC,
  GridC,
  MsgC,
  SrlC,
  TextC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as SrlC from "./_ccbSrlC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as BtnC from "./_cccBtnC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as ht from './_ht';
import * as hf from './_hf';

import * as icvi19a from './icvI19___Ti';

export const N = (pz: {
  sPz: ht.dz,
}) => {

  const _rows = [];
  const _cells = [
    {
      boxStlz: a('f/0.5'),
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          abtType: 'lblOrnz',
          textz: {
            pfx: 'ID',
          }
        })
      ]
    },
    {
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          abtType: 'lblOrnz',
          textz: {
            pfx: 'クライアント',
          }
        })
      ]
    },
    {
      boxStlz: a('f/0.25'),
      oClds: [
      ]
    },
  ];
  _rows.push(
    {
      cellCs: _cells
    },
  );

  hf.getRng(9).map( ( _nIdx: ht.n ) => {
    const _cells = [
      {
        boxStlz: a('f/0.5'),
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            textz: {
              pfx: `${_nIdx}`,
            }
          })
        ]
      },
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            textz: {
              pfx: `クライアント${_nIdx}`,
            }
          })
        ]
      },
      {
        boxStlz: a('f/0.25'),
        oClds: [
          cr.c(BtnC.N, {
            key: -10,
            abtType: 'cfmOrnz',
            lblCz: {},
            pslPtyz: {
              onPress: () => {
                pz.sPz.set({
                  steps: [1],
                })
              },
            }
          })
        ]
      },
    ];
    _rows.push(
      {
        cellCs: _cells
      },
    )
  });

  return (
    cr.c(BoxC.N, {
      key: -10,
      abtType: 'bdyCmnz',
      oClds: [

/*
        cr.c(BarC.N, {
          key: -10,
          abtType: 'ftnOrnz',
        }),
*/
        cr.c(GridC.N, {
          key: -10,
          abtType: 'barFtnOrnz',
          boxStlz: a(`mb/2`),
        }),

        cr.c(BoxC.N, {
          key: -20,
          abtType: 'cttCmnz',
          oClds: [

/*
            cr.c(MsgC.N, {
              key: -10,
              abtType: 'cttCmnz',
              boxStlz: a('mb/2'),
              cz: {
                ls: [
                  {
                    mkrCz: {
                      textz: {
                        pfx: _lblz.msgz.topz.mkr,
                      }
                    },
                    msgCz: {
                      textz: {
                        pfx: _lblz.msgz.topz.msg,
                      }
                    }
                  },
                ]
              },
            }),
*/

            cr.c(SrlC.V, {
              key: -20,
              srlStlz: {
                otrz: a('dw/f f/1'),
                inrz: a('fd/csc'),
              },
              oClds: [
                cr.c(icvi19a.L, {
                  key: -20,
                  sPz: pz.sPz,
                  cz: {
                    ccd: 'rd',
                  }
                }),
              ],
            }),

            cr.c(icvi19a.B, {
              key: -40,
              sPz: pz.sPz,
              cz: {
                lblz: pz.sPz.crt.lblz,
                sc: 'rd7',
                onPrsBack: () => {
                  cr.moveTo({
                    pageName: 'icvHomeK10Rz',
                  });
                }
              }
            })

          ]
        })

      ]
    })
  );
};
